"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isEscapeKeyDismiss", {
    enumerable: true,
    get: ()=>isEscapeKeyDismiss
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _keyboardKeys = require("@fluentui/keyboard-keys");
function isEscapeKeyDismiss(event, modalType) {
    return event.key === _keyboardKeys.Escape && modalType !== 'alert' && !event.isDefaultPrevented();
} //# sourceMappingURL=isEscapeKeyDown.js.map

//# sourceMappingURL=isEscapeKeyDown.js.map